module.exports = __webpack_public_path__ + "grape_reserved-9f75a.svg";